// Translation dictionary for FeeMitra (English + Hindi)
export const translations = {
  en: {
    brand: "FeeMitra",
    kicker: "SMART SCHOOL FEE MANAGEMENT",
    welcome_back: "WELCOME BACK",
    sign_in: "Sign in to FeeMitra",
    sign_in_hint: "Choose a demo workspace to explore the experience.",
    sign_in_hint_real: "Enter the email and password shared by your school.",
    sign_in_demo: "Demo",
    pay_online: "Pay Fees Online", sign_in_otp: "Mobile OTP", or: "or", google_sign_in: "Continue with Google", mobile_label: "Registered mobile number", send_otp: "Send OTP", otp_sent_to: "OTP sent to", change: "Change", otp_label: "Enter 6-digit OTP", verify_login: "Verify & sign in", resend_otp: "Resend OTP",
    sign_in_real: "Sign in with email",
    sign_in_button: "Sign in",
    sign_in_error: "Unable to sign in. Please try again.",
    email_label: "Email",
    password_label: "Password",
    real_access: "Secured by FeeMitra · school admin / staff / parent login",
    continue_as: "Continue as",
    signing_in: "Signing in…",
    demo_access: "Demo access is ready · No setup required",
    school_admin: "School Admin",
    staff_role: "Accountant / Staff",
    parent_role: "Parent / Guardian",
    super_role: "SaaS Owner",
    tab_super: "Manage all schools",
    tab_admin: "Manage your school",
    tab_staff: "Collect & manage payments",
    tab_parent: "View children & pay fees",
    hero_h1_a: "Clarity for every fee.",
    hero_h1_b: "Confidence for every family.",
    hero_body: "One simple place for schools to manage collections, parents to pay, and teams to stay in control.",
    live_collections: "Live collections",
    live_collections_sub: "Reconciled instantly",
    mobile_first: "Made for mobile",
    mobile_first_sub: "Hindi + English ready",
    nav_dashboard: "Dashboard",
    nav_home: "Home",
    nav_students: "Students",
    nav_fees: "Fees & dues",
    nav_fees_short: "Fees",
    nav_feeheads: "Fee heads",
    nav_structures: "Fee structures",
    nav_sessions: "Sessions",
    nav_payments: "Payments",
    nav_reports: "Reports",
    nav_notices: "Notices",
    nav_settings: "Settings",
    school_overview: "SCHOOL OVERVIEW",
    ops_overview: "OPERATIONS OVERVIEW",
    parent_portal: "PARENT PORTAL",
    greeting_morning: "Good morning",
    page_sub_admin: "Keep your school's collections moving with confidence.",
    page_sub_parent: "Here's a clear view of your children's fee status.",
    total_students: "Total students",
    total_pending: "Total pending",
    collected: "Collected",
    next_due_date: "Next due date",
    pending_fees: "Pending fees",
    payment_history: "Payment history",
    overdue: "Overdue",
    notices: "Notices",
    across_children: "Across your children",
    this_session: "This session",
    needs_attention: "Needs attention",
    follow_up: "Follow up today",
    latest_updates: "Latest updates",
    receipts_available: "Receipts available",
    oct_cycle: "October fee cycle",
    collection_snapshot: "Collection snapshot",
    your_children: "Your children",
    snapshot_sub: "Fee status across the active session.",
    children_sub: "Select a child to view and pay fees.",
    view_all: "View all",
    recent_notices: "Recent notices",
    recent_notices_sub: "Keep families informed.",
    collection_received: "Collection received",
    add_student: "Add student",
    import_csv: "Import CSV",
    view_pending: "View pending",
    add_fee_head: "Add fee head",
    add_structure: "Add structure",
    generate_fees: "Generate fees",
    new_session: "New session",
    offline_collect: "Offline collect",
    search_placeholder: "Search students, parents or admission no.",
    filter: "Filter",
    name: "Name",
    amount: "Amount",
    frequency: "Frequency",
    mandatory: "Mandatory",
    action: "Action",
    yes: "Yes",
    no: "No",
    delete: "Delete",
    class: "Class",
    class_short: "Class",
    fee_head: "Fee head",
    due_day: "Due day",
    student: "Student",
    parent: "Parent",
    pending: "Pending",
    paid: "Paid",
    partial: "Partial",
    status: "Status",
    collect: "Collect",
    discount: "Discount",
    pay_now: "Pay now",
    pending_fee: "Pending fee",
    receipt: "Receipt",
    mode: "Mode",
    date: "Date",
    no_students: "No students found. Add one from the top-right.",
    no_payments: "No payments found.",
    no_heads: "No fee heads yet. Add one from the top-right.",
    no_structs: "No structures yet. Add one from the top-right.",
    no_sessions: "No sessions yet.",
    close_sess_warn: "Close this session? Outstanding dues will be carried forward safely to the active session.",
    activate_sess: "Activate",
    close_sess: "Close & carry forward",
    active: "Active",
    closed: "Closed",
    start_date: "Start date",
    end_date: "End date",
    session_name: "Session name",
    save_session: "Save session",
    period: "Period",
    all_classes: "All classes",
    leave_blank_all: "(leave blank for all classes)",
    late_fee_overdue: "Late fee for overdue (₹)",
    run_generate: "Run generation",
    generating: "Generating…",
    created_items: "Created",
    skipped: "Skipped",
    total: "Total",
    reason: "Reason",
    apply_discount: "Apply discount",
    applying: "Applying…",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    secure_mock: "SECURE MOCK CHECKOUT",
    offline_checkout: "OFFLINE COLLECTION",
    pay_: "Pay",
    oct_fee: "October 2026 fee",
    total_payable: "Total payable",
    amount_to_pay: "Amount to pay",
    verifying: "Verifying payment…",
    server_verified: "Server-verified sandbox payment",
    cheque_no: "Cheque number",
    bank_name: "Bank name",
    collector_name: "Collector name",
    record_payment: "Record payment",
    print: "Print",
    download_pdf: "Download PDF",
    done: "Done",
    payment_receipt: "PAYMENT RECEIPT",
    receipt_no: "Receipt no.",
    transaction: "Transaction",
    amount_paid: "Amount paid",
    upload_csv: "Upload students CSV",
    csv_hint: "Columns: name, class_name, section, parent_name, parent_mobile, monthly_fee",
    upload: "Upload",
    uploading: "Uploading…",
    imported: "Imported",
    failed: "Failed",
    sibling_discount: "Sibling discount",
  },
  hi: {
    brand: "फीमित्र",
    kicker: "स्मार्ट स्कूल फीस प्रबंधन",
    welcome_back: "पुनः स्वागत है",
    sign_in: "फीमित्र में साइन इन करें",
    sign_in_hint: "अनुभव के लिए एक डेमो वर्कस्पेस चुनें।",
    sign_in_hint_real: "अपने स्कूल द्वारा साझा किया गया ईमेल और पासवर्ड दर्ज करें।",
    sign_in_demo: "डेमो",
    pay_online: "ऑनलाइन फीस भरें", sign_in_otp: "मोबाइल OTP", or: "या", google_sign_in: "Google से जारी रखें", mobile_label: "रजिस्टर्ड मोबाइल नंबर", send_otp: "OTP भेजें", otp_sent_to: "OTP भेजा गया", change: "बदलें", otp_label: "6 अंकों का OTP डालें", verify_login: "सत्यापित करें और लॉगिन करें", resend_otp: "OTP दोबारा भेजें",
    sign_in_real: "ईमेल से साइन इन",
    sign_in_button: "साइन इन",
    sign_in_error: "साइन इन नहीं हो पा रहा। कृपया पुनः प्रयास करें।",
    email_label: "ईमेल",
    password_label: "पासवर्ड",
    real_access: "FeeMitra द्वारा सुरक्षित · स्कूल एडमिन / स्टाफ / अभिभावक लॉगिन",
    continue_as: "जारी रखें",
    signing_in: "साइन इन हो रहा है…",
    demo_access: "डेमो एक्सेस तैयार है · कोई सेटअप आवश्यक नहीं",
    school_admin: "स्कूल एडमिन",
    staff_role: "अकाउंटेंट / स्टाफ",
    parent_role: "अभिभावक",
    super_role: "SaaS मालिक",
    tab_super: "सभी स्कूल प्रबंधित करें",
    tab_admin: "अपना स्कूल प्रबंधित करें",
    tab_staff: "भुगतान एकत्र करें और प्रबंधित करें",
    tab_parent: "बच्चों को देखें और फीस भरें",
    hero_h1_a: "हर फीस में स्पष्टता।",
    hero_h1_b: "हर परिवार के लिए विश्वास।",
    hero_body: "स्कूलों के लिए संग्रह प्रबंधित करने, अभिभावकों के भुगतान करने और टीमों के नियंत्रण में रहने के लिए एक सरल स्थान।",
    live_collections: "लाइव संग्रह",
    live_collections_sub: "तुरंत मिलान",
    mobile_first: "मोबाइल के लिए बना",
    mobile_first_sub: "हिंदी + इंग्लिश तैयार",
    nav_dashboard: "डैशबोर्ड",
    nav_home: "होम",
    nav_students: "छात्र",
    nav_fees: "फीस और बकाया",
    nav_fees_short: "फीस",
    nav_feeheads: "फीस हेड्स",
    nav_structures: "फीस संरचना",
    nav_sessions: "सत्र",
    nav_payments: "भुगतान",
    nav_reports: "रिपोर्ट्स",
    nav_notices: "सूचनाएँ",
    nav_settings: "सेटिंग्स",
    school_overview: "स्कूल अवलोकन",
    ops_overview: "संचालन अवलोकन",
    parent_portal: "अभिभावक पोर्टल",
    greeting_morning: "शुभ प्रभात",
    page_sub_admin: "अपने स्कूल के संग्रह को आत्मविश्वास से चलाते रहें।",
    page_sub_parent: "यहाँ आपके बच्चों की फीस स्थिति का स्पष्ट दृश्य है।",
    total_students: "कुल छात्र",
    total_pending: "कुल बकाया",
    collected: "संग्रहित",
    next_due_date: "अगली देय तिथि",
    pending_fees: "लंबित फीस",
    payment_history: "भुगतान इतिहास",
    overdue: "विलंबित",
    notices: "सूचनाएँ",
    across_children: "आपके बच्चों में",
    this_session: "इस सत्र में",
    needs_attention: "ध्यान आवश्यक",
    follow_up: "आज संपर्क करें",
    latest_updates: "नवीनतम अपडेट",
    receipts_available: "रसीदें उपलब्ध",
    oct_cycle: "अक्टूबर फीस चक्र",
    collection_snapshot: "संग्रह सारांश",
    your_children: "आपके बच्चे",
    snapshot_sub: "सक्रिय सत्र में फीस स्थिति।",
    children_sub: "फीस देखने और भरने के लिए बच्चे का चयन करें।",
    view_all: "सभी देखें",
    recent_notices: "हाल की सूचनाएँ",
    recent_notices_sub: "परिवारों को सूचित रखें।",
    collection_received: "संग्रह प्राप्त",
    add_student: "छात्र जोड़ें",
    import_csv: "CSV आयात",
    view_pending: "लंबित देखें",
    add_fee_head: "फीस हेड जोड़ें",
    add_structure: "संरचना जोड़ें",
    generate_fees: "फीस बनाएँ",
    new_session: "नया सत्र",
    offline_collect: "ऑफलाइन संग्रह",
    search_placeholder: "छात्र, अभिभावक या प्रवेश संख्या खोजें।",
    filter: "फिल्टर",
    name: "नाम",
    amount: "राशि",
    frequency: "आवृत्ति",
    mandatory: "अनिवार्य",
    action: "क्रिया",
    yes: "हाँ",
    no: "नहीं",
    delete: "हटाएँ",
    class: "कक्षा",
    class_short: "कक्षा",
    fee_head: "फीस हेड",
    due_day: "देय दिन",
    student: "छात्र",
    parent: "अभिभावक",
    pending: "लंबित",
    paid: "भुगतान",
    partial: "आंशिक",
    status: "स्थिति",
    collect: "संग्रह",
    discount: "छूट",
    pay_now: "अभी भुगतान",
    pending_fee: "लंबित फीस",
    receipt: "रसीद",
    mode: "विधि",
    date: "तिथि",
    no_students: "कोई छात्र नहीं मिला। ऊपर दाईं ओर से एक जोड़ें।",
    no_payments: "कोई भुगतान नहीं मिला।",
    no_heads: "अभी तक कोई फीस हेड नहीं। ऊपर दाईं ओर से जोड़ें।",
    no_structs: "अभी तक कोई संरचना नहीं। ऊपर दाईं ओर से जोड़ें।",
    no_sessions: "अभी तक कोई सत्र नहीं।",
    close_sess_warn: "यह सत्र बंद करें? बकाया राशि सक्रिय सत्र में सुरक्षित रूप से अग्रेषित हो जाएगी।",
    activate_sess: "सक्रिय करें",
    close_sess: "बंद करें और अग्रेषित करें",
    active: "सक्रिय",
    closed: "बंद",
    start_date: "आरंभ तिथि",
    end_date: "अंतिम तिथि",
    session_name: "सत्र का नाम",
    save_session: "सत्र सहेजें",
    period: "अवधि",
    all_classes: "सभी कक्षाएँ",
    leave_blank_all: "(सभी कक्षाओं के लिए खाली छोड़ें)",
    late_fee_overdue: "विलंबित के लिए विलंब शुल्क (₹)",
    run_generate: "जनरेशन चलाएँ",
    generating: "बना रहा है…",
    created_items: "बनाए गए",
    skipped: "छोड़े गए",
    total: "कुल",
    reason: "कारण",
    apply_discount: "छूट लागू करें",
    applying: "लागू हो रहा है…",
    save: "सहेजें",
    saving: "सहेज रहा है…",
    cancel: "रद्द",
    secure_mock: "सुरक्षित मॉक चेकआउट",
    offline_checkout: "ऑफलाइन संग्रह",
    pay_: "भुगतान",
    oct_fee: "अक्टूबर 2026 फीस",
    total_payable: "कुल देय",
    amount_to_pay: "भुगतान की राशि",
    verifying: "भुगतान सत्यापित हो रहा है…",
    server_verified: "सर्वर-सत्यापित सैंडबॉक्स भुगतान",
    cheque_no: "चेक संख्या",
    bank_name: "बैंक का नाम",
    collector_name: "संग्रहकर्ता का नाम",
    record_payment: "भुगतान दर्ज करें",
    print: "प्रिंट",
    download_pdf: "PDF डाउनलोड",
    done: "हो गया",
    payment_receipt: "भुगतान रसीद",
    receipt_no: "रसीद संख्या",
    transaction: "लेनदेन",
    amount_paid: "भुगतान राशि",
    upload_csv: "छात्र CSV अपलोड करें",
    csv_hint: "कॉलम: name, class_name, section, parent_name, parent_mobile, monthly_fee",
    upload: "अपलोड",
    uploading: "अपलोड हो रहा है…",
    imported: "आयातित",
    failed: "विफल",
    sibling_discount: "भाई-बहन छूट",
  },
};

export const useT = (lang) => (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
